import {Button, Stack, Typography} from '@mui/material';
import {Modal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {AdviceModalProps} from './types';

const {title, subtitle, sectionOne, sectionTwo, footnote} =
	translations['pt-br'].privateFlow.refund.beneficiaryDataPage.modals.adviceModal;
const {understood} = translations['pt-br'].commons;

export const AdviceModal = ({open, setOpen}: AdviceModalProps) => (
	<Modal.Root open={open} onClose={() => setOpen(false)} customMaxWidth={480}>
		<Modal.Header title={title} onClose={() => setOpen(false)} />
		<Modal.Content>
			<Stack spacing={2}>
				<Typography>{subtitle}</Typography>
				<Typography>
					<b>1. </b>
					{sectionOne.title}
				</Typography>
				<Stack pl={2} gap={1}>
					<Typography>
						<b>{sectionOne.item1Title} </b>
						{sectionOne.item1Text}
					</Typography>
					<Typography>
						<b>{sectionOne.item2Title} </b>
						{sectionOne.item2Text}
					</Typography>
				</Stack>
				<Typography>
					<b>2. </b>
					{sectionTwo.title}
				</Typography>
				<Stack pl={2} gap={1}>
					<Typography>
						<b>{sectionTwo.item1Title} </b>
						{sectionTwo.item1Text}
					</Typography>
					<Typography>
						<b>{sectionTwo.item2Title} </b>
						{sectionTwo.item2Text}
					</Typography>
					<Typography>
						<b>{sectionTwo.item3Title} </b>
						{sectionTwo.item3Text}
					</Typography>
					<Typography>
						<b>{sectionTwo.item4Title} </b>
						{sectionTwo.item4Text}
					</Typography>
					<Typography>
						<b>{sectionTwo.item5Title} </b>
						{sectionTwo.item5Text}
					</Typography>
				</Stack>
				<Typography variant="caption">{footnote}</Typography>
			</Stack>
		</Modal.Content>

		<Modal.Footer>
			<Button
				fullWidth
				variant="contained"
				size="large"
				color="primary"
				onClick={() => setOpen(false)}>
				{understood}
			</Button>
		</Modal.Footer>
	</Modal.Root>
);
